import { SWRResponse } from 'swr';
import { AutocompleteComplex } from '@atoms';

type AutocompleteComplexFetchProps = React.ComponentProps<typeof AutocompleteComplex> & {
  getOptions: () => SWRResponse<object[]>;
};

/**
 * AutocompleteComplex + SelectFetch
 * @param {*} props
 * @returns
 */
const AutocompleteComplexFetch = (props: AutocompleteComplexFetchProps) => {
  const { getOptions } = props;
  const { data } = getOptions();
  return <AutocompleteComplex {...props} items={data ?? []} />;
};

export default AutocompleteComplexFetch;
